import React, { useEffect } from "react";
import {
  TodaySalesFlowerList,
  SalesInfoSection,
  SalesInfoHeader,
  LastMonthSalesFlowerList,
  Divider,
} from "./MarketSalesInfoStyle";
import ArrowRightSvg from "assets/icons/arrow-right-gray.svg";
import ScrollContainer from "react-indiana-drag-scroll";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MarketCreators } from "redux/modules/market";

const MarketSalesInfo = () => {
  const navigate = useNavigate();
  const { marketId } = useParams();
  const dispatch = useDispatch();
  const monthlyFlowers = useSelector((state) => state.market?.monthlyFlowers);
  const dailyFlowers = useSelector((state) => state.market?.todayFlowers);
  const todayFlowersIsLoading = useSelector(
    (state) => state.market.todayFlowersIsLoading
  );
  const monthlyFlowersIsLoading = useSelector(
    (state) => state.market.monthlyFlowersIsLoading
  );
  const monthlyFlowerList =
    monthlyFlowers.data?.length >= 6
      ? monthlyFlowers.data?.slice(0, 6)
      : monthlyFlowers.data;

  // const noStockDailyFlowers = dailyFlowers.data[0]?.images;
  const dailyFlowerList =
    dailyFlowers.data?.length >= 15
      ? dailyFlowers.data?.slice(0, 15)
      : dailyFlowers.data;

  const monthlyFlowersCount =
    monthlyFlowers.data?.length >= 1 ? `${monthlyFlowers.data?.length}종` : "";

  const dailyFlowersCount =
    dailyFlowers.data?.length >= 1 ? `${dailyFlowers.data?.length}종` : "";

  useEffect(() => {
    dispatch(MarketCreators.fetchMonthlyFlowers(marketId));
    dispatch(MarketCreators.fetchTodayFlowers(marketId));
  }, []);

  return (
    <SalesInfoSection>
      <SalesInfoHeader>
        <h3 className="fresh-flower-title">
          오늘 판매중이 생화{" "}
          {dailyFlowers?.isInStock ? (
            <span className="fresh-flower-count">{dailyFlowersCount}</span>
          ) : null}
        </h3>
        {dailyFlowers?.isInStock ? (
          <img
            src={ArrowRightSvg}
            alt="more fresh flower info button"
            className="arrow-right"
            onClick={() => navigate(`/market/${marketId}/today-flowers`)}
          />
        ) : null}
      </SalesInfoHeader>
      <TodaySalesFlowerList>
        <ScrollContainer className="container">
          {todayFlowersIsLoading
            ? dailyFlowers?.isInStock === 1
              ? dailyFlowerList.map((item, index) => {
                  return (
                    <li
                      key={index}
                      className={index === 14 ? "more-info" : ""}
                      onClick={
                        index === 14
                          ? () => navigate(`/market/${marketId}/today-flowers`)
                          : () => {}
                      }
                    >
                      <div>
                        <img src={item.flowerImg} alt="flower" />
                        {index === 14 ? <p>더 보기</p> : ""}
                      </div>
                      <p>{item.flowerName}</p>
                    </li>
                  );
                })
              : dailyFlowers.data[0]?.images.map((item, index) => {
                  return (
                    <li key={index}>
                      <div>
                        <img src={item} alt="" />
                      </div>
                    </li>
                  );
                })
            : null}
        </ScrollContainer>
        {dailyFlowers?.isInStock ? (
          <button
            className="show-all-flowers-btn"
            onClick={() => navigate(`/market/${marketId}/today-flowers`)}
          >
            오늘 들어온 생화 전체보기 &gt;
          </button>
        ) : null}
      </TodaySalesFlowerList>
      <Divider />
      <SalesInfoHeader>
        <h3 className="fresh-flower-title">
          최근 한달간 판매한 생화{" "}
          {monthlyFlowers?.isInStock ? (
            <span className="fresh-flower-count">{monthlyFlowersCount}</span>
          ) : null}
        </h3>
        {monthlyFlowers?.isInStock ? (
          <img
            src={ArrowRightSvg}
            alt="more fresh flower info button"
            className="arrow-right"
            onClick={() => navigate(`/market/${marketId}/monthly-flowers`)}
          />
        ) : null}
      </SalesInfoHeader>
      <LastMonthSalesFlowerList>
        {monthlyFlowersIsLoading
          ? monthlyFlowers?.isInStock
            ? monthlyFlowerList.map((item) => {
                return (
                  <li key={item.flowerName}>
                    <img src={item.flowerImg} alt="flower" />
                    <p>{item.flowerName}</p>
                  </li>
                );
              })
            : monthlyFlowers.data[0]?.images.map((img, index) => {
                return (
                  <li key={index}>
                    <img src={img} alt="" />
                  </li>
                );
              })
          : null}
      </LastMonthSalesFlowerList>
    </SalesInfoSection>
  );
};

export default MarketSalesInfo;
